// This function import all the svg icon in assets/icons folder automatically.
// This allow svg-sprite-loader in webpack conf to create the sprite and inject it in the app's body
if (process.env.NODE_ENV !== 'test') {
  var req = require.context('../../assets/icons', false, /.*\.svg$/)
  req.keys().forEach(function(key) {
    req(key)
  })
}



// WEBPACK FOOTER //
// ./src/components/Icon/makeSvgSprite.js